import React, { useContext, useEffect, useState } from 'react'
import { Images } from 'constants';
import { AddButton, CrossButton, ButtonHeading, CommonInput, CommonTextarea, CustomPagination, CustomSelect } from 'components'
import { IoArrowBackOutline } from 'react-icons/io5';
import { errorSchema, utils } from 'helper';
import StorageService from 'utils/StorageServices/StorageServices';
import { getAddressBookDropdownListData2, getConsignorDropdownListData, getConsignorLocationDropdownListData, getSupplierDropdownListData } from '_services/dropdownServices/dropdownService';
import SingleSelectDropdownInfinite from 'components/common/SingleSelectDropdownInfinite/SingleSelectDropdownInfinite';
import toast from 'react-hot-toast';
import { fetchAddEwayBillData } from '_services/accountsServices/ewayBillServices';
import { UserContext } from 'context';
import { fetchConsignorDetailsData } from '_services/accountsServices/consignorServices';
import AddEditVehicleModal from 'modals/AddEditVehicleModal';
import AddEditSupplier from 'modals/AddEditSupplier';
import AddEditOwnDriver from 'modals/AddEditOwnDriver';
import AddAddressBook from 'modals/AddAddressBook';
import AddEditConsignor from 'modals/AddEditConsignor/AddEditConsignor';
import PermissionModal from 'modals/PermissionModal';
import { updateAddressBookApi } from '_services/accountsServices/addressBookService';
import './ewaybill.css'

const dummyOption = [
  { label: 'New York', value: 'ny' },
  { label: 'Los Angeles', value: 'la' },
  { label: 'Chicago', value: 'ch' },
  { label: 'Houston', value: 'ho' },
  { label: 'Phoenix', value: 'ph' }
]

const obj = {
  consignor_id: {},
  unit_id: {},
  consignee_id: {},
  supplier_id: {},
  consignor_location: {},
}

const EwayBillNewDetailsModal = (props) => {
  let { isOpen, onClose, fetchNextModal = () => { } } = props;

  const { ewayBillInitialData, setEwayBillInitialData, setLrModalToggleForEway, mastersChild } = useContext(UserContext);
  const masterChildParty = mastersChild?.find((i) => i?.label === "Party");
  const masterChildUnit = mastersChild?.find((i) => i?.label === "Unit");
  const masterChildConsignee = mastersChild?.find((i) => i?.label === "Consignee");

  const [formValue, setFormValue] = useState(obj);
  const [formError, setFormError] = useState({});
  const [loading, setLoading] = useState(false);
  const [consignorList, setConsignorList] = useState([]);
  const [consignorLocationList, setConsignorLocationList] = useState([]);
  const [locationLoading, setLocationLoading] = useState(false);
  const [supplierList, setSupplierList] = useState([]);

  const [isSupplier, setIsSupplier] = useState(false);
  const [isDriver, setIsDriver] = useState(false);

  const [detailsData, setDetailsData] = useState({});

  const [showOffcanvasOfSupplier, setShowOffcanvasOfSupplier] = useState(false);
  const [showOffcanvasOfDriver, setShowOffcanvasOfDriver] = useState(false);

  const [showAddEditVehicleModal, setShowAddEditVehicleModal] = useState(false);

  const [addNewDropdownSupplier, setAddNewDropdownSupplier] = useState(false);

  const [addNewUnit, setAddNewUnit] = useState(false);
  const [addNewConsignee, setAddNewConsignee] = useState(false);
  const [updateUnit, setUpdateUnit] = useState({ name: '', value: false });
  const [loadingUnitConsignee, setLoadingUnitConsignee] = useState(false);

  const [addressId, setAddressId] = useState({
    id: "",
    title: "address",
    view: false,
  });

  const [isAddConsignor, setIsAddConsignor] = useState(false);


  const onhandleSelect = async (item, name) => {
    const stateObj = { ...formValue, [name]: item };
    if (name === 'consignor_id') {
      stateObj['consignor_location'] = {}
      stateObj['unit_id'] = {}
      stateObj['consignee_id'] = {}
    }
    setFormValue(stateObj);

    if (!utils.isObjectKeyEmpty(formError)) {
      const validationResult = await utils.checkFormError(stateObj, errorSchema.newEwayDetailsSchema);
      if (validationResult === true) {
        setFormError({});
      } else {
        setFormError(validationResult);
      }
    }
  };

  const onhandleUnitSelect = async (item, name) => {
    setFormValue((s) => ({ ...s, [name]: item }));
    setUpdateUnit({ name: 'unit', value: item });
    return;
  };

  const onhandleConsigneeSelect = async (item, name) => {
    setFormValue((s) => ({ ...s, [name]: item }));
    setUpdateUnit({ name: 'consignee', value: item });
    return;
  };

  const getDropdownDataConsignorList = async () => {
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
        firm_id: isOpen?.eway_bill?.branchData?.firm_id?._id || '',
        search: '',
      }
      const res = await getConsignorDropdownListData(object);
      setLoading(false);
      if (res?.responseCode == 200) {
        let data = res?.data?.consignor_list?.map((el) => {
          return {
            ...el,
            label: el?.name,
            value: el?._id,
          }
        })
        setConsignorList(data)
      }
    } catch (error) {
      // throw error;
    }
  }

  const getDropdownLocationDataList = async (value) => {
    setLocationLoading(true)
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
        consignor_id: value,
      }
      const res = await getConsignorLocationDropdownListData(object);
      if (res?.responseCode == 200) {
        let data = res?.data?.locations?.map((el) => {
          let val = el?.gst_no ? `(${el?.gst_no})` : `(No Gst)`
          return {
            ...el,
            label: `${el?.attention} ${val}`,
            value: el?._id,
          }
        })
        setConsignorLocationList(data);
        setLocationLoading(false);
      }
    } catch (error) {
      setLocationLoading(false);
      throw error;
    }
  }

  const getDataConsignorDetails = async (compId, cosigrId) => {
    try {
      let object = {
        company_id: compId,
        consignor_id: cosigrId,
      };
      const res = await fetchConsignorDetailsData(object);
      if (res?.responseCode == 200) {
        setDetailsData(res?.data);
      }
    } catch (error) {
      if (error?.response?.data?.responseCode === 500) {
        toast.error('Invalid Company & Consignor');
      }
    }
  };

  useEffect(() => {
    if (StorageService.getCompanyId() && formValue?.consignor_id?.value) {
      getDropdownLocationDataList(formValue?.consignor_id?.value);
      getDataConsignorDetails(StorageService.getCompanyId(), formValue?.consignor_id?.value)
    }
  }, [formValue?.consignor_id])

  const getDataSupplierList = async () => {
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
        firm_id: isOpen?.eway_bill?.branchData?.firm_id?._id || "",
        limit: 100,
        offset: 1,
        search: '',
        status: 1
      }
      const res = await getSupplierDropdownListData(object);
      if (res?.responseCode == 200) {
        let list = res?.data?.supplier_list?.map((el) => {
          return {
            ...el,
            label: el?.name,
            value: el?._id
          }
        })
        setSupplierList(list)
      }
    } catch (error) {
      // throw error;
    }
  }

  useEffect(() => {
    setLoading(true);
    getDropdownDataConsignorList();
    // getDataSupplierList();
  }, [])

  useEffect(() => {
    setFormValue((s) => ({
      ...s,
      consignor_id: isOpen?.eway_bill?.consignor_list?._id ? {
        ...isOpen?.eway_bill?.consignor_list,
        label: isOpen?.eway_bill?.consignor_list?.name,
        value: isOpen?.eway_bill?.consignor_list?._id,
      } : {},
      unit_id: isOpen?.eway_bill?.from_location?._id ? {
        ...isOpen?.eway_bill?.from_location,
        name: `${+isOpen?.eway_bill?.from_location?.code} | ${isOpen?.eway_bill?.from_location?.name}`,
        label: `${+isOpen?.eway_bill?.from_location?.code} | ${isOpen?.eway_bill?.from_location?.name}`,
        value: isOpen?.eway_bill?.from_location?._id,
      } : {},
      consignee_id: isOpen?.eway_bill?.to_location?._id ? {
        ...isOpen?.eway_bill?.to_location,
        name: `${+isOpen?.eway_bill?.to_location?.code} | ${isOpen?.eway_bill?.to_location?.name}`,
        label: `${+isOpen?.eway_bill?.to_location?.code} | ${isOpen?.eway_bill?.to_location?.name}`,
        value: isOpen?.eway_bill?.to_location?._id,
      } : {},
      supplier_id: isOpen?.eway_bill?.supplier_id?._id ? {
        ...isOpen?.eway_bill?.supplier_id,
        label: isOpen?.eway_bill?.supplier_id?.name,
        value: isOpen?.eway_bill?.supplier_id?._id,
      } : {},
      vehicle_id: isOpen?.eway_bill?.vehicleData?.vehicle_no ? {
        label: isOpen?.eway_bill?.vehicleData?.vehicle_no,
        value: isOpen?.eway_bill?.vehicleData?._id,
      } : {}
    }))

  }, [isOpen?.eway_bill])

  const fetchUnit = async (search, page, limit) => {
    if (!formValue?.consignor_id?.value) return { items: [], total: 0 };

    const res = await getAddressBookDropdownListData2({
      company_id: StorageService.getCompanyId(),
      firm_id: isOpen?.eway_bill?.branchData?.firm_id?._id || "",
      offset: page,
      limit,
      search,
      consignor_id: formValue?.consignor_id?.value,
      location_point: 1
    });
    if (res?.responseCode === 200) {
      setLoading(false);
      const list = await res?.data?.list?.map((i) => ({ ...i, name: `${i?.code}${i?.code && i?.name ? " | " : ""}${i?.name}`, label: `${i?.code}${i?.code && i?.name ? " | " : ""}${i?.name}`, value: i?._id }))
      // if(!isOpen?.eway_bill?.from_location?._id) {
      //   setFormValue((s) => {
      //     return {
      //       ...s,
      //       unit_id: list?.map((el) => {
      //         return {
      //           ...el,
      //           label: el?.name,
      //           value: el?._id,
      //         }  
      //       })[0],
      //     }
      //   })
      // }
      return {
        items: list,
        total: res?.data?.total_record,
      };
    } else {
      setLoading(false);
      toast.error(res?.responseMessage);
    }
  };

  const fetchConsignee = async (search, page, limit) => {
    if (!formValue?.consignor_id?.value) return { items: [], total: 0 };

    const res = await getAddressBookDropdownListData2({
      company_id: StorageService.getCompanyId(),
      firm_id: isOpen?.eway_bill?.branchData?.firm_id?._id || "",
      offset: page,
      limit,
      search,
      consignor_id: formValue?.consignor_id?.value,
      location_point: 2
    });
    if (res?.responseCode === 200) {
      setLoading(false);
      const list = await res?.data?.list?.map((i) => ({ ...i, name: `${i?.code}${i?.code && i?.name ? " | " : ""}${i?.name}`, label: `${i?.code}${i?.code && i?.name ? " | " : ""}${i?.name}`, value: i?._id }))
      // if (!formValue?.consignee_id?.value) {
      //   setFormValue((s) => {
      //     return {
      //       ...s,
      //       consignee_id: list?.map((el) => {
      //         return {
      //           ...el,
      //           label: el?.name,
      //           value: el?._id,
      //         }
      //       })[0],
      //     }
      //   })
      // }
      return {
        items: list,
        total: res?.data?.total_record,
      };


    } else {
      setLoading(false);
      toast.error(res?.responseMessage);
    }
  };

  const singleConsignorData = async () => {
    setLoading(true);
    try {
      let object = {
        consignor_id: formValue?.consignor_id?.value,
        company_id: StorageService.getCompanyId(),
      }
      const res = await fetchConsignorDetailsData(object);
      if (res?.responseCode == 200) {
        onClose();
        const updatedObject = {
          ...isOpen,
          eway_bill: {
            ...isOpen.eway_bill,
            from_location: formValue?.unit_id,
            to_location: formValue?.consignee_id,
            material_list: !detailsData?.consignor?.permission_at_eway?.fetch_items ?
              [
                {
                  name: "Default",
                  product_desc: isOpen?.eway_bill?.material_list?.[0]?.product_desc,
                  material_code: "67ebac6a6894684905d6adae",
                  hsn_code: isOpen?.eway_bill?.material_list?.[0]?.hsn_code,
                  material_category_id: "67ebac6a6894684905d6ada8",
                  qty: utils.getTotalAmount(isOpen?.eway_bill?.material_list, "qty"),
                  qty_type: 1,
                  weight: utils.getTotalAmount(isOpen?.eway_bill?.material_list, "weight"),
                  weight_type: 0,
                  kot: utils.getTotalAmount(isOpen?.eway_bill?.material_list, "kot"),
                  amount: utils.getTotalAmount(isOpen?.eway_bill?.material_list, "amount"),
                },
              ] : isOpen?.eway_bill?.material_list,
          },
        };
        fetchNextModal({ ...res?.data?.consignor, ...updatedObject, isEditLr: true });
        // console.log('test', { ...res?.data?.consignor, ...isOpen, isEditLr: true })
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  }

  const callBothFunctions = async () => {
    setLoading(true);
    try {
      let object1 = {
        consignor_id: formValue?.consignor_id?.value,
        company_id: StorageService.getCompanyId(),
      }
      let object2 = {
        company_id: StorageService.getCompanyId(),
        firm_id: ewayBillInitialData?.branch_id?.firm_id?._id ? ewayBillInitialData?.branch_id?.firm_id?._id : StorageService.getFirmId(),
        consignor_id: formValue?.consignor_id?.value,
        branch_id: ewayBillInitialData?.branch_id?.value,
        ewbNo: ewayBillInitialData?.eway_bill_no,
        is_from: !formValue?.unit_id?.value ? true : false,
        is_to: !formValue?.consignee_id?.value ? true : false,
      }
      const consignorRes = await fetchConsignorDetailsData(object1);
      const ewayRes = await fetchAddEwayBillData(object2);
      if (consignorRes?.responseCode == 200 && ewayRes?.responseCode == 200) {
        onClose();
        let list = ewayRes?.data?.material_list ? ewayRes?.data?.material_list : isOpen?.eway_bill?.material_list;
        let location_from = ewayRes?.data?.from_location?._id ? ewayRes?.data?.from_location : (formValue?.unit_id?._id ? formValue?.unit_id : isOpen?.eway_bill?.from_location);
        let location_to = ewayRes?.data?.to_location?._id ? ewayRes?.data?.to_location : (formValue?.consignee_id?._id ? formValue?.consignee_id : isOpen?.eway_bill?.to_location);
        fetchNextModal({ ...consignorRes?.data?.consignor, ...isOpen, eway_bill: { ...isOpen.eway_bill, material_list: list, from_location: location_from, to_location: location_to }, isEditLr: true });
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  // ye api tabhi call hogi jab use unit consignee select hi naa kare or direct submit kare , tab hi api call hogi
  // agar user unit consignee changes kar leta h to api call nhi hogi

  // {isOpen?.eway_bill?.consignor_list?.gst_no && (
  //   (formValue?.consignor_location?.gst_no != isOpen?.eway_bill?.consignor_list?.gst_no) ? (
  //     <span className="input_drop_error">
  //       GST number should be same as consignor location gst number.
  //     </span>
  //   ) : <></>
  // )}

  const handleSubmit = async (event) => {
    event.preventDefault();
    const validationResult = await utils?.checkFormError(formValue, errorSchema.newEwayDetailsSchema);
    if (utils?.isObjectKeyEmpty(validationResult)) {
      if ((isOpen?.eway_bill?.consignor_list?.gst_no || isOpen?.eway_bill?.ewb_details?.userGstin) && (formValue?.consignor_location?.gst_no != (isOpen?.eway_bill?.consignor_list?.gst_no ? isOpen?.eway_bill?.consignor_list?.gst_no : isOpen?.eway_bill?.ewb_details?.userGstin))) return;

      if (!formValue?.unit_id?.value || !formValue?.consignee_id?.value) {
        callBothFunctions();
      } else {
        singleConsignorData();
      }
    } else {
      setFormError(validationResult);
      setLoading(false);
    }
  }

  useEffect(() => {
    if (consignorLocationList?.length > 0 && isOpen?.eway_bill?.consignor_list?.gst_no) {
      let findItem = consignorLocationList?.find((el) => el?.gst_no === isOpen?.eway_bill?.consignor_list?.gst_no)
      setFormValue((s) => ({
        ...s,
        consignor_location: findItem,
      }))
    }
  }, [consignorLocationList, isOpen?.eway_bill?.consignor_list?.gst_no])

  const callBackVehicle = async (data) => {
    setFormValue((s) => ({
      ...s,
      vehicle_id: {
        label: data?.vehicle_no,
        value: data?._id,
      }
    }))
  };

  const handleAddNewSupplierButtonAction = () => {
    setIsSupplier(false);
    setShowOffcanvasOfSupplier(true);
  };

  const handleAddNewVehicleButtonAction = () => {
    setIsDriver(false);
    setShowOffcanvasOfDriver(true);
  };

  const handleSupplierNextModal = () => {
    setIsSupplier(!isSupplier);
    showAddEditVehicleModal(true);
  };

  const handleDriverNextModal = () => {
    setIsDriver(!isDriver);
    showAddEditVehicleModal(true);
  };

  const addSupplierHandle = (data) => {
    setAddNewDropdownSupplier(true);
  };

  const callBackSupplier = (data) => {
    setFormValue((s) => ({
      ...s,
      supplier_id: {
        label: data?.name,
        value: data?._id,
        gst_no: data?.gst_no,
      }
    }))
    const object = {
      ...data,
      label: data?.name,
      value: data?._id,
    };
    const newSupplierList = [object, ...supplierList];
    setSupplierList(newSupplierList);
  };

  const callBackUnitData = (data) => {
    let isUpdate = data?.associate_party_id?.some((el) => el?._id === formValue?.consignor_id?.value);
    if (isUpdate) {
      setFormValue((s) => ({
        ...s,
        unit_id: {
          ...data,
          name: `${data?.code} | ${data?.name}`,
          label: `${data?.code} | ${data?.name}`,
          value: data?._id,
        }
      }))
    }
    setUpdateUnit({ name: '', value: false })
  };

  const callBackConsigneeData = (data) => {
    let isUpdate = data?.associate_party_id?.some((el) => el?._id === formValue?.consignor_id?.value);
    if (isUpdate) {
      setFormValue((s) => ({
        ...s,
        consignee_id: {
          ...data,
          name: `${data?.code} | ${data?.name}`,
          label: `${data?.code} | ${data?.name}`,
          value: data?._id,
        }
      }))
    }
    setUpdateUnit({ name: '', value: false })
  };

  const callBackConsigorData = (data) => {
    setFormValue((s) => ({
      ...s,
      consignor_id: {
        label: data?.name,
        value: data?._id,
        gst_no: data?.gst_no,
      }
    }))
    const object = {
      ...data,
      label: data?.name,
      value: data?._id,
    };
    const consignList = [object, ...consignorList];
    setConsignorList(consignList);
  };

  const isPermissionModal = async () => {
    setLoadingUnitConsignee(true);
    try {
      let value1 = isOpen?.eway_bill?.from_location?.gst_no ? isOpen?.eway_bill?.from_location?.gst_no : isOpen?.eway_bill?.ewb_details?.fromGstin;
      let value2 = isOpen?.eway_bill?.to_location?.gst_no ? isOpen?.eway_bill?.to_location?.gst_no : isOpen?.eway_bill?.ewb_details?.toGstin;
      let unitObj = {
        ...updateUnit?.value,
        gst_no: value1
      };
      let consigneeObj = {
        ...updateUnit?.value,
        gst_no: value2
      };
      const res = updateUnit?.name === 'unit' ?
        await updateAddressBookApi(unitObj) :
        await updateAddressBookApi(consigneeObj)
      if (res?.responseCode == 200) {
        setLoadingUnitConsignee(false);
        setUpdateUnit({ name: '', value: false })
      } else {
        if (res?.responseMessage) {
          toast.error(`${res?.responseMessage}`);
        }
        setLoadingUnitConsignee(false);
      }
    } catch (error) {
      setLoadingUnitConsignee(false);
    }
  };

  const noHandler = (val) => {
    if (updateUnit?.name === 'unit') {
      let isUnitName = isOpen?.eway_bill?.from_location?.name ? {
        ...isOpen?.eway_bill?.from_location,
        name: `${+isOpen?.eway_bill?.from_location?.code} | ${isOpen?.eway_bill?.from_location?.name}`,
        label: `${+isOpen?.eway_bill?.from_location?.code} | ${isOpen?.eway_bill?.from_location?.name}`,
        value: isOpen?.eway_bill?.from_location?._id,
      } : {}
      setFormValue((s) => ({
        ...s,
        unit_id: isUnitName
      }));
    }
    if (updateUnit?.name === 'consignee') {
      let isConsigneeName = isOpen?.eway_bill?.to_location?.name ? {
        ...isOpen?.eway_bill?.to_location,
        name: `${isOpen?.eway_bill?.to_location?.code} | ${isOpen?.eway_bill?.to_location?.name}`,
        label: `${isOpen?.eway_bill?.to_location?.code} | ${isOpen?.eway_bill?.to_location?.name}`,
        value: isOpen?.eway_bill?.to_location?._id,
      } : {}
      setFormValue((s) => ({
        ...s,
        consignee_id: isConsigneeName
      }));
    }
    setUpdateUnit({ name: '', value: false })
  }

  let permissionModalProps = {
    isOpen: updateUnit?.value,
    closeModal: (e) => noHandler(e),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: `Update ${updateUnit?.name}`,
    isLoading: loadingUnitConsignee,
    firstSubmitTitle: "Yes",
    firstSubmitHandler: (e) => isPermissionModal(e),
    secondSubmitTitle: "No",
    secondSubmitHandler: (e) => noHandler(e),
    message: `Are you sure you want to update ${updateUnit?.name} and gst number.`
  }

  const addNewUnitHandler = () => {
    let obj = {}
    obj['consignor_list'] = formValue?.consignor_id;
    obj['create_new'] = true;
    obj['location_point'] = 1;
    if (isOpen?.eway_bill?.ewb_details?.fromGstin) {
      obj['gst_no'] = isOpen?.eway_bill?.ewb_details?.fromGstin ? isOpen?.eway_bill?.ewb_details?.fromGstin : (isOpen?.eway_bill?.from_location?.gst_no ? isOpen?.eway_bill?.from_location?.gst_no : '-');
      obj['city'] = { label: isOpen?.eway_bill?.ewb_details?.fromPlace, value: isOpen?.eway_bill?.ewb_details?.fromPlace };
      obj['state'] = { label: utils?.codeToStateName[isOpen?.eway_bill?.ewb_details?.fromStateCode], value: utils?.codeToStateName[isOpen?.eway_bill?.ewb_details?.fromStateCode] };
      obj['name'] = isOpen?.eway_bill?.ewb_details?.fromTrdName;
      obj['pincode'] = isOpen?.eway_bill?.ewb_details?.fromPincode;
      obj['address_line1'] = isOpen?.eway_bill?.ewb_details?.fromAddr1;
    }
    // if (isOpen?.eway_bill?.from_location?.gst_no) {
    //   obj['gst_no'] = isOpen?.eway_bill?.from_location?.gst_no;
    //   obj['city'] = isOpen?.eway_bill?.from_location?.city;
    //   obj['state'] = isOpen?.eway_bill?.from_location?.state;
    //   obj['name'] = isOpen?.eway_bill?.from_location?.name;
    //   obj['pincode'] = isOpen?.eway_bill?.from_location?.pincode;
    // }
    setAddNewUnit(obj)
  }

  const addNewConsigneeHandler = () => {
    let obj = {}
    obj['consignor_list'] = formValue?.consignor_id;
    obj['create_new'] = true;
    obj['location_point'] = 2;
    if (isOpen?.eway_bill?.ewb_details?.toGstin) {
      obj['gst_no'] = isOpen?.eway_bill?.ewb_details?.toGstin ? isOpen?.eway_bill?.ewb_details?.toGstin : (isOpen?.eway_bill?.to_location?.gst_no ? isOpen?.eway_bill?.to_location?.gst_no : '-');
      obj['city'] = { label: isOpen?.eway_bill?.ewb_details?.toPlace, value: isOpen?.eway_bill?.ewb_details?.toPlace };
      obj['state'] = { label: utils?.codeToStateName[isOpen?.eway_bill?.ewb_details?.toStateCode], value: utils?.codeToStateName[isOpen?.eway_bill?.ewb_details?.toStateCode] };
      obj['name'] = isOpen?.eway_bill?.ewb_details?.toTrdName;
      obj['pincode'] = isOpen?.eway_bill?.ewb_details?.toPincode;
      obj['address_line1'] = isOpen?.eway_bill?.ewb_details?.toAddr1;
    }
    // if (isOpen?.eway_bill?.to_location?.gst_no) {
    //   obj['gst_no'] = isOpen?.eway_bill?.to_location?.gst_no;
    //   obj['city'] = isOpen?.eway_bill?.to_location?.city;
    //   obj['state'] = isOpen?.eway_bill?.to_location?.state;
    //   obj['name'] = isOpen?.eway_bill?.to_location?.name;
    //   obj['pincode'] = isOpen?.eway_bill?.to_location?.pincode;
    // } else {
    //   obj['gst_no'] = isOpen?.eway_bill?.ewb_details?.toGstin ? isOpen?.eway_bill?.ewb_details?.toGstin : (isOpen?.eway_bill?.to_location?.gst_no ? isOpen?.eway_bill?.to_location?.gst_no : '-')
    //   obj['city'] = isOpen?.eway_bill?.ewb_details?.toPlace;
    //   // obj['state'] = isOpen?.eway_bill?.to_location?.state;
    //   obj['name'] = isOpen?.eway_bill?.ewb_details?.toTrdName;
    //   obj['pincode'] = isOpen?.eway_bill?.ewb_details?.toPincode;
    // }
    setAddNewConsignee(obj);
  }

  return (
    <>
      <div className="offcanvas-header" style={{ minHeight: '70px', alignItems: 'flex-end', paddingBottom: '10px' }}>
        <div className='__ewayD_head'>
          {/* <span style={{ display: 'flex', cursor: 'pointer', color: 'var(--black-color)', fontSize: '25px' }}
            onClick={() => onClose()}
          >
            <IoArrowBackOutline />
          </span> */}
          <div style={{ width: '100%' }}>
            <h4>Eway Bill</h4>
            <p>{isOpen?.eway_bill?.ewb_details?.ewbNo ? isOpen?.eway_bill?.ewb_details?.ewbNo : '-'}</p>
          </div>
        </div>
      </div>

      <div className="offcanvas-body" style={{ height: '100%' }}>
        <div className='__detailOttr_bx'>
          <div className="__bxed_inrBx">
            <div className='__detailUpper_head'>
              <h4 className='__detailHead'>Party Detail <img src={formValue?.consignor_id?.value ? Images.verifyIcon.default : Images.warnIcon.default} alt="" /></h4>
            </div>

            <div style={{ marginTop: '4px' }}>
              <CustomSelect
                options={consignorList}
                name="consignor_id"
                label="Select Party"
                placeholder="Select Party"
                isAddButton={masterChildParty?.create === 1 ? true : false}
                addButtonAction={(e) => setIsAddConsignor(true)}
                value={formValue?.consignor_id?.value ? formValue?.consignor_id : {}}
                error={formError["consignor_id.label"]}
                // error={!!(typeof formError === "object") ? formError?.consignor_id : ""}
                onSelect={(data) => onhandleSelect(data, 'consignor_id')}
              // disabled={disableBranchConsignor ? true : false}
              />
            </div>

            <div style={{ marginTop: '4px' }}>
              <CustomSelect
                options={consignorLocationList}
                name="consignor_location"
                label="Location"
                placeholder={locationLoading ? "Loading..." : "Location"}
                value={formValue?.consignor_location?.value ? formValue?.consignor_location : {}}
                error={formError["consignor_location.label"]}
                onSelect={(data) => onhandleSelect(data, 'consignor_location')}
              />
              {formValue?.consignor_location?.gst_no && <div className='__pty_flexbx'>
                <p className="__pty_fx_detail p-1"> {formValue?.consignor_location?.gst_no} </p>
              </div>}
              {(isOpen?.eway_bill?.consignor_list?.gst_no || isOpen?.eway_bill?.ewb_details?.userGstin) && (
                (formValue?.consignor_location?.gst_no != (isOpen?.eway_bill?.consignor_list?.gst_no ? isOpen?.eway_bill?.consignor_list?.gst_no : isOpen?.eway_bill?.ewb_details?.userGstin)) ? (
                  <span className="input_drop_error">
                    GST number should be same as consignor location gst number.
                  </span>
                ) : <></>
              )}
            </div>

            <div className='__pty_flexbx'>
              <div className='__ptyFirst'>
                <p className='__pty_fx_head'>Party Name</p>
                <p className='__pty_fx_detail'>
                  {/* {formValue?.consignor_id?.label ? formValue?.consignor_id?.label : '-'} */}
                  {isOpen?.eway_bill?.consignor_list?.name ? isOpen?.eway_bill?.consignor_list?.name : (formValue?.consignor_id?.label ? formValue?.consignor_id?.label : '-')}
                </p>
              </div>

              <div className='__ptySecond'>
                <p className='__pty_fx_head'>GSTIN Number</p>
                <p className='__pty_fx_detail'>
                  {/* {formValue?.consignor_id?.gst_no ? formValue?.consignor_id?.gst_no : '-'} */}
                  {isOpen?.eway_bill?.consignor_list?.gst_no ? isOpen?.eway_bill?.consignor_list?.gst_no : (isOpen?.eway_bill?.ewb_details?.userGstin ? isOpen?.eway_bill?.ewb_details?.userGstin : (formValue?.consignor_id?.gst_no ? formValue?.consignor_id?.gst_no : '-'))}
                </p>
              </div>
            </div>
          </div>

          <div className="__bxed_inrBx">
            <div className='__detailUpper_head'>
              <h4 className='__detailHead'>From Location <img src={formValue?.unit_id?.value ? Images.verifyIcon.default : Images.warnIcon.default} alt="" /></h4>
            </div>

            <div style={{ marginTop: '4px' }}>
              <SingleSelectDropdownInfinite
                label="Select Unit"
                fetchData={fetchUnit}
                selectedItem={formValue?.unit_id}
                onChange={(data) => onhandleUnitSelect(data, 'unit_id')}
                error={!!formError["unit_id.label"]}
                errorMessage={formError["unit_id.label"]}
                isAddButton={masterChildUnit?.create === 1 ? true : false}
                addButtonAction={(e) => addNewUnitHandler(e)}
                consignorId={formValue?.consignor_id?.value}
                unitId={formValue?.unit_id?.value}
                pageSize={20}
              />
              {/* {(isOpen?.eway_bill?.from_location?.gst_no ? isOpen?.eway_bill?.from_location?.gst_no : isOpen?.eway_bill?.ewb_details?.fromGstin) && (
                (formValue?.unit_id?.gst_no != (isOpen?.eway_bill?.from_location?.gst_no ? isOpen?.eway_bill?.from_location?.gst_no : isOpen?.eway_bill?.ewb_details?.fromGstin)) ? (
                  <span className="input_drop_error">
                    GST number should be same as unit gst number.
                  </span>
                ) : <></>
              )} */}
            </div>

            <div className='__pty_flexbx'>
              <div className='__ptyFirst'>
                <p className='__pty_fx_head'>Unit Name</p>
                <p className='__pty_fx_detail'>
                  {/* {formValue?.unit_id?.label ? formValue?.unit_id?.label : '-'} */}
                  {isOpen?.eway_bill?.ewb_details?.fromTrdName ? isOpen?.eway_bill?.ewb_details?.fromTrdName : (isOpen?.eway_bill?.from_location?.name ? isOpen?.eway_bill?.from_location?.name : '-')}
                </p>
              </div>

              <div className='__ptySecond'>
                <p className='__pty_fx_head'>GSTIN Number</p>
                <p className='__pty_fx_detail'>
                  {/* {formValue?.unit_id?.gst_no ? formValue?.unit_id?.gst_no : '-'} */}
                  {isOpen?.eway_bill?.ewb_details?.fromGstin ? isOpen?.eway_bill?.ewb_details?.fromGstin : (isOpen?.eway_bill?.from_location?.gst_no ? isOpen?.eway_bill?.from_location?.gst_no : '-')}
                </p>
              </div>
            </div>

            <div className='__pty_flexbx'>
              <div className='__ptyFirst'>
                <p className='__pty_fx_head'>Location</p>
                <p className='__pty_fx_detail'>
                  {isOpen?.eway_bill?.ewb_details?.fromPlace ? `${isOpen?.eway_bill?.ewb_details?.fromPlace},` : '-'} {" "}
                  {isOpen?.eway_bill?.ewb_details?.fromStateCode ? utils?.codeToStateName[isOpen?.eway_bill?.ewb_details?.fromStateCode] : '-'}
                </p>
              </div>

              <div className='__ptySecond'>
                <p className='__pty_fx_head'>PIN Code</p>
                <p className='__pty_fx_detail'>
                  {isOpen?.eway_bill?.ewb_details?.fromPincode ? isOpen?.eway_bill?.ewb_details?.fromPincode : '-'}
                </p>
              </div>
            </div>
          </div>

          <div className="__bxed_inrBx">
            <div className='__detailUpper_head'>
              <h4 className='__detailHead'>To Location <img src={formValue?.consignee_id?.value ? Images.verifyIcon.default : Images.warnIcon.default} alt="" /></h4>
            </div>

            <div style={{ marginTop: '4px' }}>
              <SingleSelectDropdownInfinite
                label="Consignee"
                fetchData={fetchConsignee}
                selectedItem={formValue?.consignee_id}
                onChange={(data) => onhandleConsigneeSelect(data, 'consignee_id')}
                error={!!formError["consignee_id.label"]}
                errorMessage={formError["consignee_id.label"]}
                isAddButton={masterChildConsignee?.create === 1 ? true : false}
                addButtonAction={(e) => addNewConsigneeHandler(e)}
                pageSize={20}
                consignorId={formValue?.consignor_id?.value}
                consigneeId={formValue?.consignee_id?.value}
              />
              {/* {(isOpen?.eway_bill?.to_location?.gst_no ? isOpen?.eway_bill?.to_location?.gst_no : isOpen?.eway_bill?.ewb_details?.toGstin) && (
                (formValue?.consignee_id?.gst_no != (isOpen?.eway_bill?.to_location?.gst_no ? isOpen?.eway_bill?.to_location?.gst_no : isOpen?.eway_bill?.ewb_details?.toGstin)) ? (
                  <span className="input_drop_error">
                    GST number should be same as consignor gst number.
                  </span>
                ) : <></>
              )} */}
            </div>

            <div className='__pty_flexbx'>
              <div className='__ptyFirst'>
                <p className='__pty_fx_head'>Consignee Name</p>
                <p className='__pty_fx_detail'>
                  {/* {formValue?.consignee_id?.label ? formValue?.consignee_id?.label : '-'} */}
                  {isOpen?.eway_bill?.ewb_details?.toTrdName ? isOpen?.eway_bill?.ewb_details?.toTrdName : (isOpen?.eway_bill?.to_location?.name ? isOpen?.eway_bill?.to_location?.name : '-')}
                </p>
              </div>

              <div className='__ptySecond'>
                <p className='__pty_fx_head'>GSTIN Number</p>
                <p className='__pty_fx_detail'>
                  {/* {formValue?.consignee_id?.gst_no ? formValue?.consignee_id?.gst_no : '-'} */}
                  {isOpen?.eway_bill?.ewb_details?.toGstin ? isOpen?.eway_bill?.ewb_details?.toGstin : (isOpen?.eway_bill?.to_location?.gst_no ? isOpen?.eway_bill?.to_location?.gst_no : '-')}
                </p>
              </div>
            </div>

            <div className='__pty_flexbx'>
              <div className='__ptyFirst'>
                <p className='__pty_fx_head'>Location</p>
                <p className='__pty_fx_detail'>
                  {isOpen?.eway_bill?.ewb_details?.toPlace ? `${isOpen?.eway_bill?.ewb_details?.toPlace},` : '-'} {" "}
                  {isOpen?.eway_bill?.ewb_details?.toStateCode ? utils?.codeToStateName[isOpen?.eway_bill?.ewb_details?.toStateCode] : '-'}
                </p>
              </div>

              <div className='__ptySecond'>
                <p className='__pty_fx_head'>PIN Code</p>
                <p className='__pty_fx_detail'>
                  {isOpen?.eway_bill?.ewb_details?.toPincode ? isOpen?.eway_bill?.ewb_details?.toPincode : '-'}
                </p>
              </div>
            </div>
          </div>

          {/* <div className="__bxed_inrBx">
            <div className='__detailUpper_head'>
              <h4 className='__detailHead'>Supplier Detail <img src={formValue?.supplier_id?.value ? Images.verifyIcon.default : Images.warnIcon.default} alt="" /></h4>
            </div>

            <div style={{ marginTop: '4px' }}>
              <CustomSelect
                options={supplierList}
                name="supplier_id"
                flotingLabel="Supplier"
                placeholder="Supplier"
                // isDropdownTop={true}
                value={formValue?.supplier_id}
                // focus={!!(typeof formError === "object" && formError?.supplier_id)}
                error={!!(typeof formError === "object") ? formError?.supplier_id : ""}
                onSelect={(data) => onhandleSelect(data, 'supplier_id')}
                isAddButton={true}
                addButtonAction={addSupplierHandle}
              // isClearOption={true}
              // isClearHandleChange={() => {
              //   setFormValue((s) => ({ ...s, supplier_id: {} })) //  label: 'Assign Supplier', value: '' 
              // }}
              />
            </div>

            <div className='__pty_flexbx'>
              <div className='__ptyFirst'>
                <p className='__pty_fx_head'>Supplier Name</p>
                <p className='__pty_fx_detail'>
                  {formValue?.supplier_id?.label ? formValue?.supplier_id?.label : '-'}
                </p>
              </div>

              <div className='__ptySecond'>
                <p className='__pty_fx_head'>GSTIN Number</p>
                <p className='__pty_fx_detail'>
                  {formValue?.supplier_id?.gst_no ? formValue?.supplier_id?.gst_no : '-'}
                </p>
              </div>
            </div>
          </div> */}

          <div className="__bxed_inrBx">
            <div className='__detailUpper_head'>
              <h4 className='__detailHead'>Vehicle Detail <img src={formValue?.vehicle_id?.label ? Images.verifyIcon.default : Images.warnIcon.default} alt="" /></h4>
              {!formValue?.vehicle_id?.label ?
                <button className='__detailAdd_btn' onClick={(e) => setShowAddEditVehicleModal(true)}> + Add </button>
                : <></>}
            </div>

            <div className='__pty_flexbx'>
              <div className='__ptyFirst'>
                <p className='__pty_fx_head'>Vehicle Number</p>
                <p className='__pty_fx_detail'>{formValue?.vehicle_id?.label ? formValue?.vehicle_id?.label : '-'}</p>
              </div>
            </div>
          </div>

          <div className="__bxed_inrBx">
            <div className='__detailUpper_head'>
              <h4 className='__detailHead'>Eway Bill Detail</h4>
            </div>

            <div className='__pty_flexbx'>
              <div className='__ptyFirst'>
                <p className='__pty_fx_head'>Created Date</p>
                <p className='__pty_fx_detail'>
                  {isOpen?.eway_bill?.ewb_details?.ewayBillDate ? isOpen?.eway_bill?.ewb_details?.ewayBillDate : '-'}
                </p>
              </div>


              <div className='__ptySecond'>
                <p className='__pty_fx_head'>Expiry Date</p>
                <p className='__pty_fx_detail'>
                  {isOpen?.eway_bill?.ewb_details?.validUpto ? isOpen?.eway_bill?.ewb_details?.validUpto : '-'}
                </p>
              </div>
            </div>

            <div className='__pty_flexbx'>
              <div className='__ptyFirst'>
                <p className='__pty_fx_head'>Eway Bill Number</p>
                <p className='__pty_fx_detail'>
                  {isOpen?.eway_bill?.ewb_details?.ewbNo ? isOpen?.eway_bill?.ewb_details?.ewbNo : '-'}
                </p>
              </div>

              <div className='__ptySecond'>
                <p className='__pty_fx_head'>Invoice Number</p>
                <p className='__pty_fx_detail'>
                  {isOpen?.eway_bill?.ewb_details?.docNo ? isOpen?.eway_bill?.ewb_details?.docNo : "-"}
                </p>
              </div>
            </div>
          </div>

          <div className={detailsData?.consignor?.permission_at_eway?.fetch_items ? "accordion __detailAccordian" : "accordion __detailAccordian __accordionCondition"} id="accordionPanelsOpened">
            <div className="accordion-item">
              <h2 className="accordion-header" id="panelsStayOpen-headingOne">
                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="false" aria-controls="panelsStayOpen-collapseOne">
                  <span>Item Details</span>
                </button>
              </h2>
              {detailsData?.consignor?.permission_at_eway?.fetch_items ? <div id="panelsStayOpen-collapseOne" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingOne">
                <div className="accordion-body">
                  <table>
                    <thead>
                      <tr>
                        <td>Item Description</td>
                        <td>QTY</td>
                        <td>Sales Value</td>
                      </tr>
                    </thead>

                    <tbody>
                      {
                        isOpen?.eway_bill?.material_list?.map((item, index) => {
                          return (
                            <tr key={index + item?.product_desc}>
                              <td>
                                <p> {item?.product_desc} </p>
                                <span>HSN {item?.hsn_code ? item?.hsn_code : '-'}</span>
                              </td>
                              <td><p>{item?.qty}</p></td>
                              <td><p>Rs. {item?.amount ? Math.floor(item?.amount).toFixed(2) : ''}</p></td>
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  </table>
                </div>
              </div> : <></>}
              <div className='__tdFoot_main'>
                <div className='__tdFoot_df'><h4>Total Quantity</h4> <h4>Qty {utils.getTotalAmount(isOpen?.eway_bill?.material_list, 'qty')} </h4></div>
                <div className='__tdFoot_df'><h4>Invoice Value</h4> <h4>Rs. {utils.getTotalAmount(isOpen?.eway_bill?.material_list, 'amount')}</h4></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="offcanvas-footer __stk_offFooter">
        <button className="__cancelStk_btn" onClick={() => { onClose(); setLrModalToggleForEway(true) }}>
          Cancel
        </button>

        <button
          className="__saveStk_btn"
          onClick={(e) => handleSubmit(e)}
        > {loading ? 'Loading...' : 'Add Eway'}
        </button>
      </div>


      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showAddEditVehicleModal ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: showAddEditVehicleModal ? "visible" : "hidden" }}
      >
        {showAddEditVehicleModal && (
          <AddEditVehicleModal
            isOpen={showAddEditVehicleModal}
            onClose={() => setShowAddEditVehicleModal(false)}
            callBackVehicle={callBackVehicle}
            isSupplier={isSupplier}
            isDriver={isDriver}
            handleAddNewSupplierButtonAction={
              handleAddNewSupplierButtonAction
            }
            handleAddNewVehicleButtonAction={
              handleAddNewVehicleButtonAction
            }
            hideAddNewOption={false}
          />
        )}
      </div>

      <div className={showAddEditVehicleModal ? "offBack_drop" : ""}></div>

      {/* Supplier Canvas Open and Vahicle canvas will close */}
      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasOfSupplier ? "show" : ""
          }`}
        tabIndex={-1}
        style={{
          visibility: showOffcanvasOfSupplier ? "visible" : "hidden",
        }}
      >
        {showOffcanvasOfSupplier && (
          <AddEditSupplier
            isOpen={showOffcanvasOfSupplier}
            onClose={(e) => setShowOffcanvasOfSupplier(false)}
            callBackSupplier={(e) => handleSupplierNextModal(e)}
            hideAddNewOption={false}
          />
        )}
      </div>
      <div className={showOffcanvasOfSupplier ? "offBack_drop" : ""}></div>

      {/* Driver Canvas Open and Vahicle canvas will close */}
      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasOfDriver ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: showOffcanvasOfDriver ? "visible" : "hidden" }}
      >
        {showOffcanvasOfDriver && (
          <AddEditOwnDriver
            isOpen={showOffcanvasOfDriver}
            onClose={() => setShowOffcanvasOfDriver(false)}
            callBackDriver={(e) => handleDriverNextModal(e)}
            hideAddNewOption={false}
          />
        )}
      </div>
      <div className={showOffcanvasOfDriver ? "offBack_drop" : ""}></div>

      {/* single supplier dropdown add new ----- start */}
      <div
        className={`offcanvas offcanvas-end common_offCanvas ${addNewDropdownSupplier ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: addNewDropdownSupplier ? "visible" : "hidden" }}
      >
        {addNewDropdownSupplier && (
          <AddEditSupplier
            isOpen={addNewDropdownSupplier}
            onClose={() => setAddNewDropdownSupplier(false)}
            callBackSupplier={callBackSupplier}
            hideAddNewOption={false}
          />
        )}
      </div>
      <div className={addNewDropdownSupplier ? "offBack_drop" : ""}></div>
      {/* single supplier dropdown add new ----- end */}

      {/* Add New Unit Offcanvas - Start */}
      <div
        className={`offcanvas offcanvas-end common_offCanvas ${addNewUnit ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: addNewUnit ? "visible" : "hidden" }}
      >
        {addNewUnit && (
          <AddAddressBook
            isOpen={addNewUnit}
            onClose={(e) => setAddNewUnit(false)}
            callBackAddressData={(value) => callBackUnitData(value)}
            selectedAssociateParty={isOpen?.eway_bill?.consignor_list}
            isLocationPoint={1}
            hideAddNewOption={false}
            firmId={isOpen?.eway_bill?.branchData?.firm_id}
          />
        )}
      </div>
      <div className={addNewUnit ? "offBack_drop" : ""}></div>
      {/* Add New Unit Offcanvas - End */}

      {/* Add New Consignee Offcanvas - Start */}
      <div
        className={`offcanvas offcanvas-end common_offCanvas ${addNewConsignee ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: addNewConsignee ? "visible" : "hidden" }}
      >
        {addNewConsignee && (
          <AddAddressBook
            isOpen={addNewConsignee}
            onClose={(e) => setAddNewConsignee(false)}
            callBackAddressData={(value) => callBackConsigneeData(value)}
            selectedAssociateParty={isOpen?.eway_bill?.consignor_list}
            isLocationPoint={2}
            hideAddNewOption={false}
            firmId={isOpen?.eway_bill?.branchData?.firm_id}
          />
        )}

      </div>
      <div className={addNewConsignee ? "offBack_drop" : ""}></div>
      {/* Add New Consignee Offcanvas - End */}

      {/* Add New Consignor Offcanvas - start */}
      <div
        className={`offcanvas offcanvas-end common_offCanvas ${isAddConsignor ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: isAddConsignor ? 'visible' : 'hidden' }}
      >
        {isAddConsignor &&
          <AddEditConsignor
            isOpen={isAddConsignor}
            onClose={() => setIsAddConsignor(false)}
            callbackData={(value) => callBackConsigorData(value)}
            hideAddNewOption={false}
            branchFirmId={isOpen?.eway_bill?.branchData?.firm_id?._id ? isOpen?.eway_bill?.branchData?.firm_id?._id : StorageService?.getFirmId()}
          />
        }
      </div>
      <div className={isAddConsignor ? 'offBack_drop' : ''}></div>
      {/* Add New Consignor Offcanvas - start */}

      {
        updateUnit?.value
        && (
          <PermissionModal {...permissionModalProps} />
        )
      }

    </>
  )
}

export default EwayBillNewDetailsModal